import { IStatisticSchema } from './statistic-schema.interface';

export interface IDelaySchema extends IStatisticSchema {
    normalValue: string;
}

export interface IOperationalDelayTargetEntityByLocationItemSchema {
    entityName: string;
    plannedTime: string;
    permanenceTime: string;
    timeDiff: string | null;
    visitsCount: number;
    tripCodes?: string[];
    tripDetails?: IOperationalDelayTripDetailItemSchema[];
}

export interface IOperationalDelayTripDetailItemSchema {
    tripCode: string;
    permanenceTime: string;
    plannedTime: string;
    timeDiff: string;
    isOutlier: boolean;
}

export interface IOperationalDelayLocationItemSchema {
    location: string;
    locationId: string;
    totalDwellTime: string;
    totalDwellTimeMinutes: number;
    normalDwellTime: string;
    normalDwellTimeMinutes: number;
    visitsCount: number;
    excessMinutes: string;
    excessMinutesValue: number;
    excessPercentage: string;
    excessPercentageValue: number;
    targetEntities: IOperationalDelayTargetEntityByLocationItemSchema[];
}

export interface IOperationalDelayDrilldownSchema {
    topDestinations?: IOperationalDelayLocationItemSchema[];
    topOrigins?: IOperationalDelayLocationItemSchema[];
}

export interface IOperationalDelaySchema {
    averageUnloadDelay?: IDelaySchema;
    averageLoadDelay?: IDelaySchema;
    drilldown?: IOperationalDelayDrilldownSchema;
}
